import { urlAppendSearchParams } from '../url';
describe('urlAppendSearchParams', () => {
  const mockurl = `http://tests.com`;
  test('returns url with query string', () => {
    const queryParams = {
      id: '12345',
      someOtherParam: 'other',
      anotherParam: 'another',
    };
    expect(urlAppendSearchParams(mockurl, queryParams)).toEqual(
      `http://tests.com?id=12345&someOtherParam=other&anotherParam=another`
    );
  });
  test('returns url with empty parameters', () => {
    const queryParams = {};
    expect(urlAppendSearchParams(mockurl, queryParams)).toEqual(
      `http://tests.com`
    );
  });

  test('returns url with no parameter', () => {
    expect(urlAppendSearchParams(mockurl)).toEqual(`http://tests.com`);
  });
});
